import { render, staticRenderFns } from "./QuizTeamResultText.vue?vue&type=template&id=a94fe0f6&scoped=true&"
import script from "./QuizTeamResultText.vue?vue&type=script&lang=js&"
export * from "./QuizTeamResultText.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeamResultText.vue?vue&type=style&index=0&id=a94fe0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fe0f6",
  null
  
)

export default component.exports